export const isString = (v) => {
    return typeof v === "string";
};

export const isObject = (v) => {
    return !!v && typeof v === "object" && !isArray(v);
};

export const isArray = (v) => {
    return Array.isArray(v);
};

export const isEmpty = (v) => {
    return !(!!v
        ? typeof v === "object"
            ? Array.isArray(v)
                ? !!v.length
                : !!Object.keys(v).length
            : true
        : false);
};

export const isBoolean = (value) => {
    return typeof value === "boolean" ? true : false;
};

export const isValidDate = (date) => {
    return new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};

export const isAlphaNum = (value) => {
    return /^[a-z0-9 ]+$/i.test(value);
};

export const isEmail = (value) => {
    const pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    return pattern.test(value);
};

export const isFile = (input) => {
    const idxDot = input.lastIndexOf(".") + 1;
    const extFile = input.substr(idxDot, input.length).toLowerCase();
    if (extFile == "pdf" || extFile == "doc" || extFile == "docx") {
        return true;
    } else {
        return false;
    }
};

export const isBlob = (input) => {
    if ("Blob" in window && input instanceof Blob) return true;
    else return false;
};

export const isImage = (input) => {
    const idxDot = input.lastIndexOf(".") + 1;
    const extFile = input.substr(idxDot, input.length).toLowerCase();
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
        return true;
    } else {
        return false;
    }
};

export const isAlphaNumSpaceDash = (input) => {
    return /^[A-Za-z0-9? ,_-]+$/.test(String(input));
};

export const isInteger = (input) => {
    return Number.isInteger(input);
};

export const isNumber = (input) => {
    return typeof input == "number" && !isNaN(input);
};

export const isValidUrl = (input) => {
    return /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(
        input
    );
};

export const isValidPassword = (input) => {
    return new RegExp(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,}$/
    ).test(input);
};

export const isValidName = (input) => {
    return /^[A-Za-z? ._-]+$/.test(value).test(input);
};

export const isDevelopment = () => {
    return (
        ["local", "staging", "development"].includes(
            process.env.MIX_REACT_APP_ENV
        ) || process.env.MIX_REACT_APP_ENV === undefined
    );
};

export const isTrue = (value) =>
    value === true || value === "true" || value === "1" || value === 1;

export const isValidBDPhone = (value) =>
    /^((01|8801|\+8801)\d{9}|(\+91|91|0)?[789]\d{9})$/.test(value);

export const isValidTextAreaValue = (value) =>
    /^[a-zA-Z0-9_!"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~\s]*$/.test(value);

export default {
    isString,
    isObject,
    isArray,
    isEmpty,
    isBoolean,
    isValidDate,
    isAlphaNum,
    isEmail,
    isFile,
    isBlob,
    isAlphaNumSpaceDash,
    isNumber,
    isInteger,
    isValidUrl,
    isImage,
    isValidPassword,
    isValidName,
    isDevelopment,
    isValidBDPhone,
};
